import useRootData from '~/hooks/useRootData';

export default function useFeature(
  featureId: string
): [boolean, Record<string, unknown>] {
  const rootData = useRootData();
  const features = rootData?.featuresAndVariables;
  const feature = features?.[featureId];
  const enabled = !!feature?.enabled;
  return [enabled, feature?.variables ?? {}];
}
